import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IChannelSelectOption } from '@x/ecommerce-shop/app/channel/state';

@Component({
  selector: 'x-channel-picker-opton',
  templateUrl: './channel-picker-opton.component.html',
  styleUrls: ['./channel-picker-opton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChannelPickerOptonComponent {
  @Input() channel?: IChannelSelectOption;

  get imageurl() {
    if (!this.channel) return;

    if (this.channel.code === 'int') {
      return 'https://res.cloudinary.com/babylon/image/upload/v1667208396/babylonstoren/icons/filled_globe.svg';
    }

    let imgcode = this.channel.defaultCountry ?? this.channel.code;

    if (!imgcode) return;
    return `https://flagcdn.com/${imgcode.toLowerCase()}.svg`;
  }
}
